import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const NewsletterEvents: AnalyticsBrandSettings = {

  newsletterNewsletterAltaNewsletterOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const newsletterType = componentData.newsletter;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'newsletter', 'newsletter', 'alta_newsletter_ok', newsletterType
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },
  newsletterNewsletterBajaNewsletterOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const newsletterType = componentData.newsletter;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'newsletter', 'newsletter', 'baja_newsletter_ok', newsletterType
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },
  newsletterNewsletterErrorNewsletter(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const field = componentData.field;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'newsletter', 'newsletter', 'error_newsletter', field
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },
  newsletterNewsletterErrorServidorNewsletter(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const label = `cod_${componentData.errorCode}-desc_${componentData.errorDescription}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'newsletter', 'newsletter', 'error_newsletter', label
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },
  newsletterLegalVerPoliticaPrivacidad(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'legal', 'newsletter', 'ver_politica_privacidad'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },
};
